import gql from "graphql-tag";

const getContentQuery = gql`
  query ContentDetails {
    sections {
      id
      name
      sort
      videos {
        id
        name
        sort
        videoUrl
        duration
        isCompleted
        slug
      }
    }
  }
`;

export { getContentQuery };
